import { parseDateWithFormat, isValid, add, formatDate } from 'lib/dates';

export default function Time(params) {
    let { value, inputFormat, outputFormat, offset, locale = 'en-US' } = params;

    const dateCell = document.createElement('div');
    dateCell.classList.add('w5-date-cell');
    if (!value || typeof value !== 'string') {
        return dateCell;
    }

    let stringValue = '';
    if (!inputFormat) {
        if (value.includes(' ')) inputFormat = 'dd/MM/yyyy HH:mm:ss';
        else inputFormat = 'dd/MM/yyyy';
    }

    if (value && typeof value !== 'string' && value.value) value = value.value;

    if (value && value.indexOf('1900') === -1) {
        try {
            let date = parseDateWithFormat(value, locale, inputFormat);
            if (isValid(date)) {
                if (offset && !isNaN(parseInt(offset, 10))) {
                    date = add(date, { minutes: offset * 60 });
                }
                stringValue = formatDate(date, locale, outputFormat);
            }
        } catch {
            stringValue = value;
        }
    }

    dateCell.innerText = stringValue;
    return dateCell;
}
